import React, {useState, useMemo, useRef, useEffect} from "react"
import useRescuers from "hooks/useRescuers"
import Rescuer from "components/Rescuer"
import "./RescuerSelect.css"


/** Autocomplete and select a rescuer */
export default function RescuerSelect(props) {

    const {onClick} = props
    const placeholder = props.placeholder ?? "Pretraga spasilaca..."
    const [query, setQuery] = useState("")
    const {filter} = useRescuers()
    const resultsRef = useRef(null)


    const results = useMemo(() => {
        return filter(query)
    }, [filter, query])

    useEffect(() => {
        if (results.length > 0 && resultsRef.current) {
            resultsRef.current.scrollIntoView({behavior: 'smooth', block: 'nearest'})
        }
    }, [results])


    return <div id="rescuer-select">
        <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder={placeholder}/>

        <div className="search-results" ref={resultsRef}>
            {results.map(rescuer => <Rescuer key={rescuer.username} rescuer={rescuer} onClick={onClick}/>)}
        </div>
    </div>

}
